function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#mention_svg__clip0_886_1364)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.333 8a3.333 3.333 0 11-6.666 0 3.333 3.333 0 016.666 0zm0 0V5.333m0 2.667v1.297c0 .703.334 1.703 1.334 1.703 1.333 0 2-1.532 2-3a6.667 6.667 0 10-3.704 5.974",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "mention_svg__clip0_886_1364"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})));

var SvgMention = function SvgMention(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "#666A72"
  }, props), _ref, _ref2);
};

export default SvgMention;